import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import Time from "react-time-format";
import { Button, Input, Select, Modal, Tooltip } from "antd";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import Swal from "sweetalert2";
import CreateExp from "./CreateExp";
import {
  Delete_Type_Exp,
  Get_List_Exp,
  Update_Type_Exp,
  View_Type_Exp,
} from "../../actions/Account_action";
import Icons from "../../components/HOC/Icons";
const ListType_Expenses = () => {
  const dispatch = useDispatch();
  const [ismodal, setismodal] = useState(false);
  const [name_ku, setname_ku] = useState("");
  const [name_en, setname_en] = useState("");
  const [name_ar, setname_ar] = useState("");
  const [ismodalview, setismodalview] = useState(false);
  const [search, setsearch] = useState("");
  const [pending, setPending] = useState(true);
  const view_exp = useSelector((state) => state.AccountReducer.view_exp);
  const list_expenses = useSelector(
    (state) => state.AccountReducer.list_expenses
  );
  useEffect(() => {
    dispatch(Get_List_Exp());
    setname_ku(view_exp && view_exp.name_ku);
    setname_en(view_exp && view_exp.name_en);
    setname_ar(view_exp && view_exp.name_ar);
    const timeout = setTimeout(() => {
      setPending(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [view_exp]);

  const lang = useSelector((state) => state.HelperReducer.lang);
  const onCloseModel = () => {
    setismodal(false);
  };
  const onOpenModel = () => {
    setismodal(true);
  };
  const onCloseModel_View = () => {
    setismodalview(false);
  };
  const onOpenModel_View = (id) => {
    dispatch(View_Type_Exp(id));
    setismodalview(true);
  };
  const Update_Type_Expenses = () => {
    const data = {
      name_ku,
      name_ar: name_ar !== "" ? name_ar : name_ku,
      name_en: name_en !== "" ? name_en : name_ku,
    };
    if (name_ku === "") {
      Swal.fire({
        title: "OPS",
        text: dispatch(change_Lang("Please Check Inputs")),
        icon: "error",
        html: `<b class="fk">${dispatch(
          change_Lang("Please Check Inputs")
        )}</b>`,
        confirmButtonText: dispatch(change_Lang("Ok")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      dispatch(Update_Type_Exp(view_exp._id, data));
      setTimeout(() => {
        dispatch(Get_List_Exp());
      }, 1500);
      onCloseModel_View();
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${dispatch(
          change_Lang("You successfully tainted your work")
        )}</b>`,
        icon: "success",
        confirmButtonText: dispatch(change_Lang("success")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
    }
  };
  const onDelete_Exp = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      text: dispatch(change_Lang("You won't be able to delete this!")),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Delete_Type_Exp(id));
        dispatch(Get_List_Exp());
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };

  const datas = list_expenses
    .filter((data) => {
      if (search !== "") {
        if (isNaN(search)) {
          if (
            data.name_ku &&
            data.name_ku.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return data.name_ku
              ? data.name_ku.toLowerCase().startsWith(search.toLowerCase())
              : "";
          } else if (
            dispatch(change_Lang(data.type)) &&
            dispatch(change_Lang(data.type))
              .toLowerCase()
              .startsWith(search.toLowerCase())
          ) {
            return dispatch(change_Lang(data.type))
              ? dispatch(change_Lang(data.type))
                  .toLowerCase()
                  .startsWith(search.toLowerCase())
              : "";
          } else if (
            data.name_ar &&
            data.name_ar.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return data.name_ar
              ? data.name_ar.toLowerCase().startsWith(search.toLowerCase())
              : "";
          } else if (
            data.name_en &&
            data.name_en.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return data.name_en
              ? data.name_en.toLowerCase().startsWith(search.toLowerCase())
              : "";
          }
        }
      } else {
        return data;
      }
    })
    .reverse()
    .map((el, i) => {
      return {
        id: list_expenses.length - i,
        name_ku: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.name_ku}</span>
        ),
        name_en: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.name_en}</span>
        ),
        name_ar: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.name_ar}</span>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        action: (
          <>
            <Tooltip title="Update">
              <Button
                style={{
                  background: "#efefed",
                  color: "#4064d7",
                  paddingTop: "6px",
                }}
                shape="circle"
                onClick={() => {
                  onOpenModel_View(el._id);
                }}
              >
                <Icons name={"fas fa-edit"} />
              </Button>
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <Button
                onClick={() => {
                  onDelete_Exp(el._id);
                }}
                style={{
                  background: "#efefed",
                  color: "#4064d7",
                  paddingTop: "6px",
                }}
                shape="circle"
              >
                {" "}
                <Icons name={"fas fa-ban"} />
              </Button>
            </Tooltip>
          </>
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("Number")),
      selector: "id",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("expenses (Kurdish)")),
      selector: "name_ku",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("expenses (Arabic)")),
      selector: "name_ar",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("expenses (English)")),
      selector: "name_en",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const { Option } = Select;
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("List of Cost Types"))}
          parent={dispatch(change_Lang("Create Cost"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12 ">
              <div>
                <div className="row ">
                  <div className="col-md-3 text-right">
                    <button
                      onClick={onOpenModel}
                      className="btn btn-sm ml-5 exp_btn"
                    >
                      {dispatch(change_Lang("Increase spending"))}
                    </button>
                  </div>
                  <div className="col-md-6">
                    <div className=" text-center mt-2">
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#4064d7",
                          fontSize: "21px",
                        }}
                      >
                        {dispatch(change_Lang("List of Cost Types"))}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-2 m-auto" style={{ background: "" }}>
                    <div className="form-group form-inline d-flex justify-content-center">
                      <Input
                        type="text"
                        name="search"
                        value={search}
                        onChange={(e) => setsearch(e.target.value)}
                        size="middle"
                        placeholder={dispatch(change_Lang("Search"))}
                        autoComplete="off"
                        className="mt-2"
                        prefix={<Search color="lightgray" />}
                      />
                    </div>
                  </div>
                </div>
                <div className="row user-status table-responsive latest-order-table table-striped">
                  <div className="co-12">
                    <DataTable
                      striped="true"
                      progressPending={pending}
                      customStyles={customStyles}
                      columns={columns}
                      data={datas}
                      pagination="true"
                      noDataComponent={dispatch(change_Lang("table_display"))}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title={dispatch(change_Lang("Create Cost"))}
          open={ismodal}
          onOk={onCloseModel}
          onCancel={onCloseModel}
          width={"800px"}
          footer={false}
          className="fk"
          centered
          bodyStyle={{ background: "#f6f8fa" }}
        >
          <CreateExp onCloseModel={onCloseModel} />
        </Modal>
        {/* Update & View */}
        <Modal
          title={dispatch(change_Lang("Update Cost"))}
          open={ismodalview}
          onOk={onCloseModel_View}
          onCancel={onCloseModel_View}
          width={"800px"}
          footer={false}
          className="fk"
          centered
          bodyStyle={{ background: "#f6f8fa" }}
        >
          <div>
            <h4 className="d-flex justify-content-center">
              {dispatch(change_Lang("Update Cost"))}
            </h4>
            <div className="form-group row">
              <label className="col-xl-3 col-md-4">
                <span>*</span>
                {dispatch(change_Lang("expenses (Kurdish)"))}
              </label>
              <input
                className="form-control col-xl-8 col-md-7"
                name="name_ku"
                value={name_ku}
                type="text"
                onChange={(e) => setname_ku(e.target.value)}
                required
                autoComplete="off"
              />
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-md-4">
                <span>*</span>
                {dispatch(change_Lang("expenses (Arabic)"))} :
              </label>
              <input
                className="form-control col-xl-8 col-md-7"
                name="name_ar"
                value={name_ar === 0 ? "" : name_ar}
                type="text"
                onChange={(e) => setname_ar(e.target.value)}
                required
                autoComplete="off"
              />
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-md-4">
                <span>*</span>
                {dispatch(change_Lang("expenses (English)"))}:
              </label>
              <input
                className="form-control col-xl-8 col-md-7"
                name="name_en"
                value={name_en === 0 ? "" : name_en}
                type="text"
                onChange={(e) => setname_en(e.target.value)}
                required
                autoComplete="off"
              />
            </div>
            <Button
              className="ml-4 fk"
              type="primary"
              shape="round"
              style={{
                background: "#d7e4eb",
                color: "#4b85a4",
                border: "none",
              }}
              htmlType="submit"
              onClick={() => {
                Update_Type_Expenses();
              }}
            >
              {dispatch(change_Lang("profile_updatebt"))}
            </Button>
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

export default ListType_Expenses;
